import { useEffect } from 'react';
import { PauseDetails } from '../Types';
import { toDate } from '../util';
import useListEditState from './useListEditState';
import { v4 as uuidv4 } from 'uuid';

export const useEditPauseState = (treatmentEpisode?: TreatmentEpisode) => {
  const initialState: PauseDetails[] = treatmentEpisode?.pausedDetails
    ? treatmentEpisode.pausedDetails.map((p) => ({
        end: toDate(p.endDate),
        id: p.externalId,
        key: p.externalId,
        reason: p.pausedReason,
        start: toDate(p.startDate),
      }))
    : [];
  const { reset, ...state } = useListEditState<PauseDetails>(
    () => ({
      end: undefined,
      id: undefined,
      key: uuidv4(),
      reason: undefined,
      start: undefined,
    }),
    (item) => !item.start || !item.reason,
    initialState,
  );

  const resetState = (state?: PauseDetails[]) => {
    let newState: PauseDetails[] = [];
    if (treatmentEpisode?.pausedDetails) {
      newState = treatmentEpisode.pausedDetails.map((p) => ({
        end: toDate(p.endDate),
        id: p.externalId,
        key: p.externalId,
        reason: p.pausedReason,
        start: toDate(p.startDate),
      }));
    } else if (state) {
      newState = [...state];
    }
    reset(newState);
  };

  useEffect(() => {
    resetState();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [treatmentEpisode]);

  return {
    resetState,
    ...state,
  };
};
